import React, { useState, useEffect } from 'react';
import { Box, Button, Checkbox, FormControlLabel, TextField, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

function LoginForm({ onSubmit, error, isLoading, showForgotPassword = true, submitButtonText = 'Войти' }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [localError, setLocalError] = useState(null);

  useEffect(() => {
    setLocalError(error);
  }, [error]);

  useEffect(() => {
    setLocalError(null);
  }, [username, password]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      username,
      password,
      rememberMe,
    });
  };

  return (
    <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
      <TextField
        onChange={(e) => setUsername(e.target.value)}
        value={username}
        id="username"
        label="Логин"
        type="text"
        fullWidth
        margin="normal"
        required
        name="username"
        autoComplete="username"
        autoFocus
        disabled={isLoading}
      />
      <TextField
        onChange={(e) => setPassword(e.target.value)}
        value={password}
        id="password"
        type="password"
        label="Пароль"
        fullWidth
        margin="normal"
        required
        name="password"
        autoComplete="current-password"
        disabled={isLoading}
      />
      {localError ? (
        <Typography variant="body1" component="p" sx={{ color: 'red', margin: '10px' }}>
          {localError}
        </Typography>
      ) : null}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={rememberMe}
              color="primary"
              onChange={(e) => setRememberMe(e.target.checked)}
              disabled={isLoading}
            />
          }
          label="Запомнить меня"
        />
        {showForgotPassword && (
          <Link to="/forgotPassword" variant="body2" style={{ textDecoration: 'none' }}>
            Восстановить пароль
          </Link>
        )}
      </Box>

      <Button
        type="submit"
        fullWidth
        variant="contained"
        sx={{ mt: 3, mb: 2 }}
        disabled={username.length === 0 || password.length === 0 || isLoading}
      >
        {submitButtonText}
      </Button>
    </Box>
  );
}

LoginForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  error: PropTypes.string,
  isLoading: PropTypes.bool,
  showForgotPassword: PropTypes.bool,
  submitButtonText: PropTypes.string,
};

LoginForm.defaultProps = {
  error: null,
  isLoading: false,
  showForgotPassword: true,
  submitButtonText: 'Войти',
};

export default LoginForm;
